import Api from 'redux/api';
import { t } from 'i18next';

export default class HomePageApi extends Api {
  getHomepageConfig = async (props) => {
    const { trace_id, path } = props
    try {
      const apiData = await this.get(`home/config?trace_id=${trace_id}&path=${path}`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: t('GRAAS_FAIL_TO_LOAD_DATA_GRAAS')
      };
    }
  };
}
